// Message Service - OOP Business Logic
import { MessageRepository } from '../repositories/MessageRepository';
import { IMessage, IMessageDetail, IQueueJob } from '../interfaces/IMessage';
import { SendSingleMessageDto, SendGroupMessageDto, SendBulkMessageDto, SendGroupsQueuedDto } from '../dto/MessageDto';

export class MessageService {
  constructor(private messageRepository: MessageRepository) {}

  async sendSingleMessage(dto: SendSingleMessageDto): Promise<IMessage> {
    return this.messageRepository.sendSingle(dto);
  }

  async sendToGroup(dto: SendGroupMessageDto): Promise<IMessage> {
    return this.messageRepository.sendToGroup(dto);
  }

  async sendGroupsQueued(dto: SendGroupsQueuedDto): Promise<IQueueJob> {
    return this.messageRepository.sendGroupsQueued(dto);
  }

  async sendBulkMessage(dto: SendBulkMessageDto): Promise<IMessage> {
    return this.messageRepository.sendBulk(dto);
  }

  async getAllMessages(): Promise<IMessage[]> {
    return this.messageRepository.getAll();
  }

  async getMessageById(id: string): Promise<IMessageDetail> {
    return this.messageRepository.getById(id);
  }

  async getQueueJob(jobId: string): Promise<IQueueJob> {
    return this.messageRepository.getQueueJob(jobId);
  }

  getStatusColor(status: string): string {
    const colors: Record<string, string> = {
      PENDING: '#FFA500',
      SENT: '#4CAF50',
      FAILED: '#F44336',
    };
    return colors[status] || '#757575';
  }

  calculateSuccessRate(message: IMessage): number {
    if (message.recipientsCount === 0) return 0;
    return ((message.successCount || 0) / message.recipientsCount) * 100;
  }
}
